import { clsx } from 'clsx';
import { Overlay } from '@treezor/design-system';

import { Outlet, useLocation } from 'react-router-dom';

import { Header } from '@/ui-kit/header/Header';

import { Sidebar } from '@/router/components/sidebar/Sidebar';
import { useSidebar } from '@/router/hooks/useSidebar';

import { Alerts } from '@/ui-kit/alerts/Alerts';
import { useAlerts } from '@/ui-kit/alerts/useAlerts';

import { useDashboardConfig } from '@/hooks/useDashboardConfig';

import { ViewedProfile } from '@/features/user/components/ViewedProfile';

export const DashboardLayout = () => {
  const { pathname } = useLocation();
  const { shouldShowOverlay } = useAlerts();

  const { isOpen, ...sidebarProps } = useSidebar();
  const dashboardConfig = useDashboardConfig();
  const userCreationTypes = dashboardConfig.settings.users?.creation;

  // Page with fullScreen mode
  const fullscreenPaths = [...(userCreationTypes?.length ? ['app/create-user'] : [])];

  const isFullScreen = fullscreenPaths.some((path) => pathname.includes(path));

  return (
    <div className="flex h-screen">
      <Alerts />

      {!isFullScreen && <Sidebar isOpen={isOpen} {...sidebarProps} />}
      <div
        className={clsx(
          'flex flex-col h-screen',
          isFullScreen ? 'flex-1' : isOpen ? 'w-[calc(100vw_-_256px)]' : 'w-full pl-[72px]',
        )}
      >
        {!isFullScreen && <Header />}

        {!isFullScreen ? (
          <div className="m-6 flex flex-col h-[calc(100vh-90px)]">
            <ViewedProfile />
            <div className="overflow-y-auto bg-primary rounded-200 border-primary border shadow-100 h-full grow pb-0">
              <Outlet />
            </div>
          </div>
        ) : (
          <div className="overflow-y-auto grow pb-0">
            <Outlet />
          </div>
        )}
      </div>
      <Overlay isVisible={shouldShowOverlay} closeOnClick={false} className="z-[1000]" />
    </div>
  );
};
